import { Component, Input, OnInit } from '@angular/core';

import { MobileRecoveryService } from '@app/modules/mobile-recovery/mobile-recovery.service';

import { ModalRef } from '@trilogy';

export enum RecoverySteps {
    Search,
    Listing,
    Result,
}

@Component({
    selector: 'btl-modal-recovery',
    templateUrl: './modal-recovery.component.html',
    styleUrls: ['./modal-recovery.component.scss'],
})
export class ModalRecoveryComponent implements OnInit {
    @Input() public useDefaultStep = false;
    @Input() modalRef: ModalRef<this>;

    public recoverySteps = RecoverySteps;
    public currentStep = this.recoverySteps.Search;
    public forfait_bonus_reprise: string;

    constructor(private mobileRecoveryService: MobileRecoveryService) {}

    public ngOnInit(): void {
        this.currentStep = this.useDefaultStep ? this.recoverySteps.Search : this.getLastStepToComplete();
    }

    public nextStep(): void {
        this.currentStep++;
        this.mobileRecoveryService.setItem(
            this.mobileRecoveryService.MOBILE_RECOVERY_STEP_STORAGE_KEY,
            this.currentStep,
        );
    }

    public previousStep(): void {
        this.currentStep--;
    }

    public goToSearchStep(): void {
        this.currentStep = this.recoverySteps.Search;
        this.mobileRecoveryService.removeItem(this.mobileRecoveryService.MOBILE_RECOVERY_STEP_STORAGE_KEY);
    }

    private getLastStepToComplete(): RecoverySteps {
        let lastStep = this.recoverySteps.Search;
        const searchedPhone = this.mobileRecoveryService.getItem('recoverySelectedPhone');
        const currentRecoveryStep = this.mobileRecoveryService.getItem(
            this.mobileRecoveryService.MOBILE_RECOVERY_STEP_STORAGE_KEY,
        );

        if (searchedPhone && currentRecoveryStep >= this.recoverySteps.Listing) {
            lastStep = this.recoverySteps.Listing;

            if (
                this.mobileRecoveryService.getDevis(searchedPhone.id) &&
                currentRecoveryStep === this.recoverySteps.Result
            ) {
                lastStep = this.recoverySteps.Result;
            }
        }

        return lastStep;
    }

    public closeModal(): void {
        this.modalRef.close();
    }
}
